module.exports = __webpack_public_path__ + "../resources/img/ic_acmodule_right 1.0facd321.svg";